import { render } from "./termplanqte.vue?vue&type=template&id=175f6682&scoped=true"
import script from "./termplanqte.vue?vue&type=script&lang=js"
export * from "./termplanqte.vue?vue&type=script&lang=js"

import "./termplanqte.vue?vue&type=style&index=0&id=175f6682&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175f6682"]])

export default __exports__